<template>
    <div class="loading-dots" :class="size && `size_${size}`">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { Size } from '../Loading.interfaces';

    export default defineComponent({
        name: 'Dots',
        components: {},
        props: {
            size: {
                type: String as PropType<Size>,
                default: 'm',
            },
        },
    });
</script>

<style lang="scss" scoped>
    @forward './Dots.scss';
</style>
